var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 38,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M3.658 0v1.58c0 .658 0 .658.682.658 5.396 0 10.803-.034 16.2.011 7.44.068 13.961 5.044 15.904 12.235 1.488 5.499.409 10.543-3.102 15.053-.113.147-.33.284-.51.284-1.535.022-3.057.011-4.59.011-.069 0-.137-.011-.273-.034l.432-.352c4.214-3.5 5.952-7.987 4.76-13.326-1.193-5.34-4.68-8.679-9.986-10.008-1.034-.261-2.136-.307-3.204-.318-5.248-.034-10.485-.012-15.734-.012-.59 0-.59 0-.59.58 0 .409.011.818 0 1.238 0 .102-.069.204-.091.307-.091-.046-.216-.068-.284-.137A470.185 470.185 0 0 1 .114 4.215c-.069-.08-.069-.341 0-.42C1.159 2.6 2.227 1.42 3.284.238 3.35.17 3.453.136 3.657 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M37.046 29.98c.181.159.295.238.375.329 1 1.113 1.999 2.238 3.01 3.351.227.25.239.41 0 .67-1.011 1.091-1.988 2.216-2.988 3.318-.102.113-.238.193-.443.352a26.934 26.934 0 0 0-.034-.705c-.023-.488-.057-.977-.08-1.465-.488-.023-.976-.057-1.476-.057-5.17-.011-10.35.034-15.518-.023-7.51-.068-14.28-5.577-15.905-12.905-1.147-5.27-.056-10.065 3.25-14.336.193-.25.386-.353.715-.341 1.545.023 3.09.011 4.726.011-.136.125-.205.205-.284.261-3.772 2.977-5.532 6.873-5.226 11.668.375 5.861 5.067 10.973 10.85 11.905.874.136 1.771.205 2.669.205 5.226.022 10.463.01 15.689.01.613 0 .613 0 .613-.601v-1.148c-.011-.136.023-.272.057-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M27.935 13.416c-.114.194-.205.375-.318.523-.557.659-.693 1.397-.375 2.181.318.784.931 1.216 1.783 1.307.637.068.762.216.773.874v1.443c0 .614-.136.761-.761.84-1.33.16-2.17 1.24-1.897 2.512.068.34.272.681.488.965.33.466.352.693-.057 1.102a53.91 53.91 0 0 1-1.147 1.136c-.34.33-.625.352-.966.046-.67-.591-1.42-.75-2.249-.42-.83.34-1.238.988-1.306 1.874-.046.5-.239.659-.739.67-.5.011-.988 0-1.488 0-.716 0-.83-.114-.92-.818-.16-1.284-1.261-2.113-2.51-1.84-.353.08-.694.306-1 .51-.41.285-.66.307-1.012-.033a59.966 59.966 0 0 1-1.204-1.204c-.33-.341-.34-.614-.034-.966.59-.67.75-1.431.41-2.25-.33-.806-.966-1.226-1.841-1.294-.557-.046-.705-.228-.705-.796V18.29c0-.647.125-.784.784-.863 1.295-.16 2.136-1.227 1.875-2.477-.069-.352-.284-.704-.5-1.01-.318-.455-.33-.682.057-1.069.374-.386.76-.76 1.147-1.147.363-.352.625-.364 1-.046.659.58 1.408.739 2.215.42.83-.329 1.25-.976 1.33-1.862.044-.534.226-.682.772-.693.534-.012 1.079-.012 1.613 0 .534.011.704.159.75.704.08.875.5 1.51 1.306 1.84.818.341 1.579.17 2.25-.409.352-.306.636-.295.965.034.409.398.806.796 1.204 1.205.114.125.182.306.307.5Zm-7.611.966c-2.545-.023-4.613 2.045-4.624 4.601a4.603 4.603 0 0 0 4.6 4.635 4.61 4.61 0 0 0 4.647-4.59c0-2.578-2.033-4.623-4.623-4.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M10.883 35.773h-.454c-2.102 0-4.192.012-6.294-.011-.375 0-.5.114-.477.488.023.534.011 1.068.011 1.727-.204-.125-.34-.182-.431-.272C2.204 36.556 1.18 35.41.136 34.262c-.159-.181-.193-.306-.022-.5 1.056-1.17 2.101-2.34 3.146-3.51.069-.08.17-.125.353-.272.022.306.045.5.045.704.011.386.011.761 0 1.147-.011.296.114.398.398.387a63.19 63.19 0 0 1 2.079 0c.159 0 .352.045.454.147 1.295 1.307 2.726 2.408 4.294 3.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M29.707 2.238h6.691c.58 0 .58 0 .58-.59V0c.215.148.352.204.443.307 1.022 1.136 2.033 2.283 3.067 3.408.204.216.182.363 0 .568L37.42 7.69c-.08.09-.228.136-.341.193-.034-.125-.091-.261-.102-.386a27.174 27.174 0 0 1 0-1.363c.01-.273-.103-.375-.375-.375-.705.011-1.42.011-2.125 0-.159 0-.352-.057-.454-.16a19.99 19.99 0 0 0-4.226-3.26c-.011 0-.023-.023-.091-.102Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 29.172,
    x2: 4.698,
    y1: 4.844,
    y2: 27.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 32.678,
    x2: 8.204,
    y1: 13.011,
    y2: 35.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 25.747,
    x2: 10.859,
    y1: 12.609,
    y2: 23.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 8.555,
    x2: 1.966,
    y1: 31.278,
    y2: 37.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 38.296,
    x2: 31.802,
    y1: 1.28,
    y2: 7.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40.624v38H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.271025a34857eca996e8202bb5dfab34.svg";
export { ForwardRef as ReactComponent };